import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { updateUser } from '../api/users';
import UserDetails from '../components/UserDetails';
import { AiOutlineIe } from 'react-icons/ai';
import BookPage from '../components/common/BookPage';

const AccountPage: React.FC = () => {
  const { user, token, setUser } = useAuth();

  const handleSaveName = async (firstName: string, lastName: string) => {
    if (!user || !token) return;

    const updatedUser = await updateUser(
      user.id,
      { first_name: firstName, last_name: lastName },
      token,
    );

    setUser(updatedUser);
    localStorage.setItem('user', JSON.stringify(updatedUser));
  };

  if (!user) {
    return (
      <div className="min-h-screen pt-16 md:pt-20">
        <section className="mx-auto max-w-4xl px-4 py-16">
          <div className="rounded-[2rem] border border-red-200 bg-red-50/80 p-8 text-center shadow-[0_18px_50px_rgba(44,32,27,0.08)]">
            <AiOutlineIe className="mx-auto mb-4 text-6xl text-red-400" />
            <h2 className="font-serif text-3xl text-red-700">Access denied.</h2>
            <p className="mt-3 text-red-700">You are not logged in. Please sign in to access your account.</p>
          </div>
        </section>
      </div>
    );
  }

  return (
    <BookPage
      eyebrow="Account"
      title="Account details."
      intro="A small corner of the site that belongs to you."
      bodyClassName="mx-auto max-w-3xl"
    >
      <UserDetails user={user} onSaveName={handleSaveName} />
    </BookPage>
  );
};

export default AccountPage;
